import { Stack, Typography, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { parseToLocalDate } from '../../../../common/utils/parseToLocalDate';
import { CardStatus } from '../CardStatus/CardStatus';
import { UserTransactionCardProps } from './types';

export const UserTransactionCard: React.FC<UserTransactionCardProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="column"
      sx={(theme: Theme) => ({
        borderRadius: '15px',
        padding: { xs: '12px' },
        border: `1px solid ${theme.palette.gray[200]}`,
        gap: { xs: '5px' },
      })}
    >
      {data.status && (
        <>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body1" color="gray.50">
              {parseToLocalDate(data.updatedAt)}
            </Typography>
            <CardStatus
              chargingStatus={data.status}
              text="userHistoryPage.card.status"
            />
          </Stack>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body1" color="common.white">
              {t('userHistoryPage.card.transactionId')}: {data.tranId}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body1" color="common.white">
              {t('userHistoryPage.card.amount')}: {data.amount / 100}₴
            </Typography>
          </Stack>
        </>
      )}
    </Stack>
  );
};
